import { useAthleteAuthContext } from "./useAthleteAuthContext";
import { Link,useNavigate } from "react-router-dom";

export const useAthleteLogout = () => {

    const { dispatch } = useAthleteAuthContext();
    const navigate = useNavigate();

    
    const logout = () => {
     //remove user from local storage
     localStorage.removeItem('athlete');
     //dispatch logout action
     dispatch({type: 'ATHLETE_LOGOUT'});
     navigate('/athlete/login');
     
    }
    return { logout };
}